'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const SwanMenuTriggerContext = createContext(void 0);
function useSwanMenuTriggerContext() {
    return useNonNullishContext(SwanMenuTriggerContext);
}

export { SwanMenuTriggerContext, useSwanMenuTriggerContext };
